<template lang="html">

  <section class="onboarding">
    <div class="wrapper d-flex align-items-center auth onboarding-full-bg h-100">
      <div class="row w-100">
        <div class="col-11 col-md-10 col-lg-8 mx-auto box-onboarding my-2">
          <div class="auth-form-dark text-left pt-3 pb-4">
            <div class="text-center mb-3">
              <img src="@/assets/images/consulta-ja-logo-colorida.svg" width="150px" alt="Consulta Já" />
            </div>
            <div class="px-4 text-center mb-3">
              <h5 class="font-weight-light">Vamos configurar a sua conta para a sua primeira agenda. Posteriormente você pode alterar e incluir mais informações se desejar.</h5>
            </div>
            <div class="onboarding-steps">
              <div class="onboarding-step step-1" :class="user != null && user.person.client.onboarding_step == 1 ? 'active' : ''">1. Dados do Consultório</div>
              <div class="onboarding-step step-2" :class="user != null && user.person.client.onboarding_step == 2 ? 'active' : ''">2. Dados do Profissional</div>
              <div class="onboarding-step step-3" :class="user != null && user.person.client.onboarding_step == 3 ? 'active' : ''">3. Agenda</div>
              <div class="onboarding-step step-4" :class="user != null && user.person.client.onboarding_step == 4 ? 'active' : ''">4. Cartão Digital</div>
            </div>
            <form v-if="user != null && user.person.client.onboarding_step == 1" :key="user.person.client.onboarding_step" class="pt-4 px-4 onboarding-form" autocomplete="off">
              <validation-observer ref="step1Form" v-slot="{ invalid }">
                <b-row class="mb-3">
                  <b-col cols="auto">
                    <div class="logo-container">
                      <div id="clientLogo" class="client-logo rounded" title="Marca" @click="$refs.fileInput.$el.childNodes[0].click()"></div>
                      <b-button class="delete-logo" size="sm" variant="danger" v-if="(currentLogo || logoFile || step1Form.logo)" @click="removeLogo"><i class="far fa-trash-alt"></i></b-button>
                      <label class="cj-label d-block">Selecionar marca</label>
                      <b-form-file class="d-block" style="width: 1px; height: 1px;opacity: 0" v-model="logoFile" accept=".jpg, .png" placeholder="" ref="fileInput" @input="logoChanged"></b-form-file>
                    </div>
                  </b-col>
                  <b-col>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">Nome da Clínica ou Profissional</label>
                        <b-form-input type="text" v-model="step1Form.name"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">CPF / CNPJ</label>
                        <validation-provider name="CPF / CNPJ" :rules="{ cpfOrCnpj: true }" v-slot="{ errors }">
                          <b-form-input type="tel" v-model="step1Form.document" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['###.###.###-##', '##.###.###/####-##']"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <label class="cj-label">Telefone profissional</label>
                        <b-form-input type="text" v-model="step1Form.telephone" v-mask="(step1Form.telephone != null && step1Form.telephone.length == 15)?'(##) #####-####':'(##) ####-#####'"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Celular / Whatsapp profissional</label>
                        <b-form-input type="text" v-model="step1Form.cellphone" v-mask="'(##) #####-####'"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">E-mail profissional</label>
                        <b-form-input type="text" v-model="step1Form.email"></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
<!--                <b-row class="mb-3">-->
<!--                </b-row>-->
                <b-row>
                  <b-col>
                    <h6 class="font-weight-light mb-1">Endereço</h6>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">CEP</label>
                    <b-form-input type="tel" v-model="step1Form.address.zip_code" v-mask="'#####-###'" v-on:blur="findCep(step1Form.address.zip_code)"></b-form-input>
                  </b-col>
                  <b-col cols="8">
                    <label class="cj-label">Endereço</label>
                    <b-form-input type="text" v-model="step1Form.address.address" ref="address"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Número</label>
                    <b-form-input type="tel" v-model="step1Form.address.number" ref="number"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col>
                    <label class="cj-label">Complemento</label>
                    <b-form-input type="text" v-model="step1Form.address.complement"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Bairro</label>
                    <b-form-input type="text" v-model="step1Form.address.neighborhood"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Cidade</label>
                    <b-form-input type="text" v-model="step1Form.address.city"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Estado</label>
                    <b-form-input type="text" v-model="step1Form.address.state"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="text-right">
                    <b-button variant="primary" @click="saveStep1" :disabled="!canPerformAction">Continuar</b-button>
                  </b-col>
                </b-row>
              </validation-observer>
            </form>
            <form v-else-if="user != null && user.person.client.onboarding_step == 2" :key="user.person.client.onboarding_step" class="pt-4 px-4 onboarding-form" autocomplete="off">
              <validation-observer ref="step2Form" v-slot="{ invalid }">
                <b-row class="mb-2">
                  <b-col cols="auto">
                    <div class="photo-container">
                      <div id="personPhoto" class="person-photo rounded" title="Foto" @click="$refs.fileInput2.$el.childNodes[0].click()"></div>
                      <b-button class="delete-photo" size="sm" variant="danger" v-if="(currentPhoto || photoFile || step2Form.photo)" @click="removePhoto"><i class="far fa-trash-alt"></i></b-button>
                      <label class="cj-label d-block">Selecionar foto</label>
                      <b-form-file class="d-block" style="width: 1px; height: 1px;opacity: 0" v-model="photoFile" accept=".jpg, .png" placeholder="" ref="fileInput2" @input="photoChanged"></b-form-file>
                    </div>
                  </b-col>
                  <b-col>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">Nome do Profissional</label>
                        <validation-provider name="nome" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="step2Form.name" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">CPF</label>
                        <validation-provider name="CPF" :rules="{ cpf: true }" v-slot="{ errors }">
                          <b-form-input type="tel" v-model="step2Form.document" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['###.###.###-##']"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Indicador na agenda</label>
                        <b-form-input type="color" v-model="step2Form.indicator_color"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <label class="cj-label">Especialidades</label>
                        <multiselect v-model="step2Form.specialities" :options="specialities" track-by="name" label="name" :preselect-first="false" :showLabels="false" :allow-empty="false" :searchable="true" :multiple="true" placeholder="Especialidade"></multiselect>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">Número do Registro</label>
                    <validation-provider name="número do registro" :rules="{ required: false }" v-slot="{ errors }">
                      <b-form-input type="text" v-model="step2Form.professional_registration.number" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Conselho Profissional</label>
                    <validation-provider name="conselho profissional" :rules="{ required: false }" v-slot="{ errors }">
                      <b-form-input type="text" v-model="step2Form.professional_registration.council" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Estado do Conselho</label>
                    <validation-provider name="estado do conselho" :rules="{ required: false, length: 2 }" v-slot="{ errors }">
                      <b-form-input type="text" v-model="step2Form.professional_registration.state" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">E-mail</label>
                    <validation-provider name="e-mail" :rules="{ required: true, email: true }" v-slot="{ errors }">
                      <b-form-input type="email" v-model="step2Form.email" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Celular</label>
                    <b-form-input type="tel" v-model="step2Form.cellphone" v-mask="'(##) #####-####'" autocomplete="off"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Telefone</label>
                    <b-form-input type="tel" v-model="step2Form.telephone" v-mask="'(##) ####-####'" autocomplete="off"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col>
                    <label class="cj-label">Data de Nascimento</label>
                    <date-picker name="date" v-model="step2Form.birthday" v-mask="'##/##/####'" :config="datePickerOptions"></date-picker>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Sexo</label>
                    <multiselect v-model="step2Form.gender" :options="genderOptions" track-by="name" label="name" :preselect-first="true" :showLabels="false" :allow-empty="false" :searchable="false"></multiselect>
                  </b-col>
                  <b-col>
                    <validation-provider name="% de comissão" :rules="{ required: true, valueLowerOrEqual100: true }" v-slot="{ errors }">
                      <label class="cj-label">% de comissão</label>
                      <money v-model="step2Form.commission_percentage" prefix="" suffix=" %" maxlength="7" class="form-control mb-2" :class="{ 'error': errors.length > 0 }" autocomplete="off"></money>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="text-right">
                    <b-button variant="primary" @click="saveStep2" :disabled="!canPerformAction">Continuar</b-button>
                  </b-col>
                </b-row>
              </validation-observer>
            </form>
            <form v-else-if="user != null && user.person.client.onboarding_step == 3" :key="user.person.client.onboarding_step" class="pt-4 px-4 onboarding-form" autocomplete="off">
              <validation-observer ref="step3Form" v-slot="{ invalid }">
                <b-row class="mb-3">
                  <b-col cols="auto">
                    <div class="logo-container">
                      <div id="agendaLogo" class="agenda-logo rounded" title="Marca" @click="$refs.fileInput3.$el.childNodes[0].click()"></div>
                      <b-button class="delete-logo" size="sm" variant="danger" v-if="(currentLogoAgenda || logoFileAgenda || step3Form.logo)" @click="removeLogoAgenda"><i class="far fa-trash-alt"></i></b-button>
                      <label class="cj-label d-block">Selecionar marca</label>
                      <b-form-file class="d-block" style="width: 1px; height: 1px;opacity: 0" v-model="logoFileAgenda" accept=".jpg, .png" placeholder="" ref="fileInput3" @input="logoChangedAgenda"></b-form-file>
                    </div>
                  </b-col>
                  <b-col>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">Nome da Agenda</label>
                        <validation-provider name="nome" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="step3Form.name" :class="{ 'error': errors.length > 0 }"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Duração média</label>
                        <multiselect v-model="step3Form.duration" :options="durations" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Duração média"></multiselect>
                      </b-col>
<!--                      <b-col>-->
<!--                        <label class="cj-label">Termo da mensagem</label>-->
<!--                        <multiselect v-model="step3Form.term" :options="terms" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Termo da mensagem"></multiselect>-->
<!--                      </b-col>-->
                    </b-row>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">Profissionais que atendem nesta agenda</label>
                        <validation-provider name="profissionais" :rules="{ required: true }" v-slot="{ errors }">
                          <multiselect v-model="step3Form.professionals" :options="professionals" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" :multiple="true" placeholder="Profissionais que atendem nesta agenda" :class="{ 'error': errors.length > 0 }"></multiselect>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Dias de funcionamento da agenda</label>
                        <ul class="days-of-week">
                          <li v-for="dow in [0, 1, 2, 3, 4, 5, 6]" :key="dow" @click="toggleDow(dow)" :class="{ 'enabled': daysOfWeekEnabled.includes(dow) }">{{ moment().weekday(dow).format('ddd') }}</li>
                        </ul>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <label class="cj-label">Tipos de atendimento</label>
                        <validation-provider name="tipos de atendimento" :rules="{ required: true }" v-slot="{ errors }">
                          <multiselect v-model="step3Form.appointmentTypes" :options="appointmentTypes" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" :multiple="true" placeholder="Tipos de atendimento desta agenda" :class="{ 'error': errors.length > 0 }"></multiselect>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label class="cj-label">Formatos de atendimento</label>
                        <validation-provider name="formatos de atendimento" :rules="{ required: true }" v-slot="{ errors }">
                          <multiselect v-model="step3Form.appointmentFormats" :options="appointmentFormats" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" :multiple="true" placeholder="Formatos de atendimento desta agenda" :class="{ 'error': errors.length > 0 }"></multiselect>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <h6 class="font-weight-light mb-2">Configuração de horários</h6>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col cols="12" md="auto" v-for="dow in daysOfWeekEnabled" :key="dow" style="flex: 1;" class="p-0">
                    <div class="box-cj mb-0">
                      <div class="header text-center">
                        <p class="title">{{ moment().weekday(dow).format('dddd') }}</p>
                      </div>
                      <div class="content">
                        <b-row>
                          <b-col>
                            <label class="cj-label">Horário de Início</label>
                            <validation-provider name="horário de início" :rules="{ required: true, regex: '^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$' }" v-slot="{ errors }" :bails="false">
                              <b-form-input type="text" v-model="getScheduleByDow(dow).start_time" v-mask="'##:##'" :class="{ 'error': errors.length > 0 }"></b-form-input>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <label class="cj-label">Horário de Término</label>
                            <validation-provider name="horário de término" :rules="{ required: true, regex: '^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$' }" v-slot="{ errors }" :bails="false">
                              <b-form-input type="text" v-model="getScheduleByDow(dow).end_time" v-mask="'##:##'" :class="{ 'error': errors.length > 0 }"></b-form-input>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                        </b-row>
                        <div class="text-center" v-if="getBreaks(dow).length > 0">
                          <hr class="my-2">
                          <small>Intervalos</small><br/>
                          <ul class="breaks mb-0">
                            <li v-for="(brk, index) in getBreaks(dow)" :key="index" @click="removeBreak(brk.id)">
                              <i class="far fa-stopwatch"></i> {{ brk.start_time }} - {{ brk.end_time }}
                              <div class="remove">
                                <i class="far fa-trash-alt mr-2"></i> Clique para remover
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="footer">
                        <b-button variant="success" @click="openModalBreak(dow)" block>Novo intervalo</b-button>
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <b-row class="mb-2">
                  <b-col cols="12">
                    <table class="table table-responsive table-bordered m-0" style="display: table;">
                      <tbody>
                      <tr>
                        <td>Permitir agendamento Online</td>
                        <td class="text-center">
                          <div class="pretty p-switch p-fill">
                            <input type="checkbox" v-model="step3Form.online_scheduling" />
                            <div class="state p-success">
                              <label></label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
                <b-row class="mb-3" v-if="step3Form.online_scheduling">
                  <b-col>
                    <label class="cj-label">Período aberto para agendamento (dias)</label>
                    <validation-provider name="período aberto para agendamento" :rules="{ required: true, between:[1,120] }" v-slot="{ errors }">
                      <b-form-input type="number" min="1" step="1" max="120" v-model="step3Form.online_scheduling_period" :class="{ 'error': errors.length > 0 }"></b-form-input>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Convênios</label>
                    <validation-provider name="convênios" :rules="{ required: true }" v-slot="{ errors }">
                      <multiselect v-model="step3Form.health_plans" :options="healthPlans" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" :multiple="true" placeholder="Convênios" :class="{ 'error': errors.length > 0 }"></multiselect>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="text-right">
                    <b-button variant="primary" @click="saveStep3" :disabled="!canPerformAction">Continuar</b-button>
                  </b-col>
                </b-row>
              </validation-observer>
            </form>
            <form v-else-if="user != null && user.person.client.onboarding_step == 4" :key="user.person.client.onboarding_step" class="pt-4 px-4 onboarding-form" autocomplete="off">
              <validation-observer ref="step4Form" v-slot="{ invalid }">
                <b-row class="mb-3">
                  <b-col cols="12">
                    <table class="table table-responsive table-bordered m-0" style="display: table;">
                      <tbody>
                      <tr>
                        <td>Cartão digital</td>
                        <td class="text-center">
                          <div class="pretty p-switch p-fill">
                            <input type="checkbox" v-model="step4Form.professional_profile.enabled" />
                            <div class="state p-success">
                              <label></label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
                <b-row class="mb-3" v-if="step4Form.professional_profile.enabled">
                  <b-col cols="12" md="8">
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">Seu link para divulgação</label>
                        <validation-provider name="link para divulgação" :rules="{ required: true, slug: true }" v-slot="{ errors }">
                          <b-input-group :prepend="digitalCardUrl">
                            <b-form-input type="text" v-model="step4Form.professional_profile.slug" :class="{ 'error': errors.length > 0 }"></b-form-input>
                            <b-input-group-append>
                              <b-button @click="copyDigitalCardUrl"><i class="far fa-copy"></i></b-button>
                            </b-input-group-append>
                          </b-input-group>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                        <div>
                          <b-form-textarea class="copyDigitalCardUrlTextArea" :value="getDigitalCardUrl()" ref="digitalCardUrl"></b-form-textarea>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12" lg="6">
                        <b-row>
                          <b-col cols="auto pt-2">
                            <div class="photo-container">
                              <div id="personPhotoProfile" class="person-photo rounded" title="Foto" @click="$refs.fileInputProfile.$el.childNodes[0].click()"></div>
                              <b-button class="delete-photo" size="sm" variant="danger" v-if="(currentPhotoProfile || photoFileProfile || step4Form.photo)" @click="removePhotoProfile"><i class="far fa-trash-alt"></i></b-button>
                              <label class="cj-label d-block">Selecionar foto</label>
                              <b-form-file class="d-block" style="width: 1px; height: 1px;opacity: 0" v-model="photoFileProfile" accept=".jpg, .png" placeholder="" ref="fileInputProfile" @input="photoChangedProfile"></b-form-file>
                            </div>
                          </b-col>
                          <b-col>
                            <b-row class="mb-2">
                              <b-col>
                                <label class="cj-label">Cor primária</label>
                                <b-form-input type="color" v-model="step4Form.professional_profile.primary_color"></b-form-input>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col>
                                <label class="cj-label">Cor secundária</label>
                                <b-form-input type="color" v-model="step4Form.professional_profile.secondary_color"></b-form-input>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="12" lg="6">
                        <b-row>
                          <b-col cols="auto pt-2">
                            <div class="photo-container">
                              <div id="professionalProfileBackgroundImage" class="person-photo rounded" title="Imagem de fundo" @click="$refs.professionalProfileBackgroundImageInput.$el.childNodes[0].click()"></div>
                              <b-button class="delete-photo" size="sm" variant="danger" v-if="(currentProfessionalProfileBackgroundImage || professionalProfileBackgroundImageFile || step4Form.professional_profile.background_image)" @click="removeProfessionalProfileBackgroundImagePhoto"><i class="far fa-trash-alt"></i></b-button>
                              <label class="cj-label d-block">Selecionar imagem<br>de fundo</label>
                              <b-form-file class="d-block" style="width: 1px; height: 1px;opacity: 0" v-model="professionalProfileBackgroundImageFile" accept=".jpg, .png" placeholder="" ref="professionalProfileBackgroundImageInput" @input="professionalProfileBackgroundImageChanged"></b-form-file>
                            </div>
                          </b-col>
                          <b-col>
                            <b-row class="mb-2">
                              <b-col>
                                <label class="cj-label">Estilo da imagem de fundo</label>
                                <multiselect v-model="step4Form.professional_profile.background_image_style" :options="backgroundImageStyles" track-by="name" label="name" :showLabels="false" :searchable="false" placeholder="Selecione um tipo de campo"></multiselect>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col>
                                <label class="cj-label">Cor de fundo</label>
                                <b-form-input type="color" v-model="step4Form.professional_profile.background_color"></b-form-input>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <h6 class="font-weight-light mb-2">Itens no seu Cartão Digital</h6>
                      </b-col>
                    </b-row>
                    <b-row class="mb-3">
                      <b-col>
                        <b-row>
                          <b-col cols="8">
                            <multiselect v-model="fieldType" :options="fieldTypes" track-by="name" label="name" :showLabels="false" :searchable="false" placeholder="Selecione um tipo de campo"></multiselect>
                          </b-col>
                          <b-col>
                            <b-button variant="primary" block class="mr-3" @click="openFieldModal">Adicionar</b-button>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="mb-2">

                        <draggable v-model="step4Form.professional_profile.items" group="people" @start="drag=true" @end="drag=false" @change="profileFieldsChanged" tag="b-list-group">
                          <b-list-group-item v-for="(field, index) in step4Form.professional_profile.items" :key="field.id" class="d-flex justify-content-between align-items-center">
                            {{ (field.name !== null && field.name !== '') ? (field.name + ' - ') : '' }}{{ field.content }}
                            <b-button @click="editField(index)"><i class="far fa-edit"></i></b-button>
                          </b-list-group-item>
                        </draggable>
                      </b-col>
                    </b-row>

                  </b-col>
                  <b-col cols="12" md="4">
                    <b-row class="mb-3">
                      <b-col cols="6" offset="3" md="12" offset-md="0">
                        <label class="cj-label">Prévia</label>
                        <div id="professionalProfilePreview" :style='"background-color:" + step4Form.professional_profile.background_color + ";" + step4Form.professional_profile.background_image_style.css'>
                          <div class="p-3 d-flex flex-column align-items-center">
                            <div id="professionalProfilePhotoPreview" class="mb-3"></div>
                            <div class="professional-name mb-1" :style='"color:" + step4Form.professional_profile.primary_color'>{{step4Form.name}}</div>
                            <div class="mb-1" :style='"color:" + step4Form.professional_profile.secondary_color'>{{getFormattedProfessionalRegistration()}}</div>
                            <div class="mb-4" :style='"color:" + step4Form.professional_profile.secondary_color'>{{getFormattedSpecialties()}}</div>

                            <div v-for="(field, index) in step4Form.professional_profile.items" :key="field.id + '_' + index" class="custom-field mb-2 d-flex justify-content-between align-items-center" :class="field.name !== '' ? 'text-left' : ''">
                              <div>
                                <div v-if="field.name !== ''" class="mb-1" :style='"color:" + step4Form.professional_profile.secondary_color'>{{field.name}}</div>
                                <div class="custom-field-content" :style='"color:" + step4Form.professional_profile.primary_color'>{{field.content}}</div>
                              </div>
                              <div class="icon" v-if="field.show_icon && getProfileFieldIcon(field.type) !== ''" :style='"color:" + step4Form.professional_profile.primary_color'>
                                <i :class="getProfileFieldIcon(field.type) + ' mr-2'"></i>
                              </div>
                            </div>
                          </div>
                          <div class="professional-card-footer p-2 mt-3" :style='"color:" + step4Form.professional_profile.primary_color + ";border-color:" + step4Form.professional_profile.secondary_color'>powered by Consultaja.com</div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="text-right">
                    <b-button variant="primary" @click="saveStep4" :disabled="!canPerformAction">Finalizar</b-button>
                  </b-col>
                </b-row>
              </validation-observer>
            </form>


            <div class="mt-5 px-4 text-center">
              <a class="logout-btn" @click="logout"><i class="far fa-sign-out"></i> Sair</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="break-modal" class="break-modal" :modalClass="'break-modal'" @hidden="resetBreakModal">
      <template slot="modal-header">
        Adicionar novo intervalo
      </template>
      <template slot="default">
        <validation-observer ref="breakForm" v-slot="{ invalid }">
          <b-container>
            <b-row class="mb-2">
              <b-col>
                <label class="cj-label">Horário de Início</label>
                <validation-provider name="horário de início" :rules="{ required: true, regex: '^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$' }" v-slot="{ errors }">
                  <b-form-input type="text" v-model="breakForm.start_time" v-mask="'##:##'" :class="{ 'error': errors.length > 0 }"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col>
                <label class="cj-label">Horário de Término</label>
                <validation-provider name="horário de término" :rules="{ required: true, regex: '^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$' }" v-slot="{ errors }">
                  <b-form-input type="text" v-model="breakForm.end_time" v-mask="'##:##'" :class="{ 'error': errors.length > 0 }"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
            </b-row>
          </b-container>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('break-modal')">Fechar</b-button>

        <b-button-group size="sm">
          <b-button variant="success" @click="addBreak">Adicionar</b-button>
        </b-button-group>
      </template>
    </b-modal>
    <b-modal id="field-modal" class="field-modal" size="lg" :modalClass="'field-modal'" @hidden="resetFieldModal">
      <template slot="modal-header">
        Adicionar novo campo
      </template>
      <template slot="default">
        <validation-observer ref="fieldForm" v-slot="{ invalid }">
          <b-container>
            <b-row class="mb-2">
              <b-col>
                <label class="cj-label">Tipo do campo</label>
                <validation-provider name="tipo de campo" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="fieldForm.type" :options="fieldTypes" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione um tipo de campo" :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value != 'text'">
                <label class="cj-label">Mostrar ícone</label>
                <validation-provider name="mostrar ícone" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="fieldForm.show_icon" :options="showIconOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione uma agenda" :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col>
                <label class="cj-label">Nome do campo</label>
                <b-form-input type="text" v-model="fieldForm.name"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col v-if="fieldForm.type.value == 'agenda'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="fieldForm.url" :options="agendas" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione uma agenda" :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'agenda'">
                <label class="cj-label">Texto da Agenda Online</label>
                <b-form-input type="text" v-model="fieldForm.content" autocomplete="off"></b-form-input>
              </b-col>

              <b-col v-if="fieldForm.type.value == 'email'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true, email: true }" v-slot="{ errors }">
                  <b-form-input type="email" v-model="fieldForm.content" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'address'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="text" v-model="fieldForm.content" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'instagram'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true, instagramUsername: true }" v-slot="{ errors }">
                  <b-input-group prepend="@">
                    <b-form-input type="text" v-model="fieldForm.content" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  </b-input-group>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>

              <b-col v-if="fieldForm.type.value == 'link'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="url" v-model="fieldForm.url" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'link'">
                <label class="cj-label">Texto do link</label>
                <b-form-input type="text" v-model="fieldForm.content" autocomplete="off"></b-form-input>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'phone'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="tel" v-model="fieldForm.content" v-mask="'(##) #####-####'" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'whatsapp'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="tel" v-model="fieldForm.content" v-mask="'(##) #####-####'" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'text'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-textarea v-model="fieldForm.content" rows="3" :class="{ 'error': errors.length > 0 }"></b-form-textarea>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
            </b-row>


          </b-container>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('field-modal')">Fechar</b-button>

        <b-button-group size="sm">
          <b-button variant="danger" v-if="fieldForm.id != null" @click="removeField(fieldForm.id)">Remover</b-button>
          <b-button variant="success" @click="addField">{{ (fieldForm.id == null?'Adicionar':'Editar') }}</b-button>
        </b-button-group>
      </template>
    </b-modal>
  </section>

</template>

<script lang="js">
import axios from "axios";

export default {
  data () {
    return {
      leavingPage: false,
      isLoading: null,
      user: null,
      digitalCardUrl: process.env.VUE_APP_DIGITAL_CARD_URL,
      aolUrl: process.env.VUE_APP_AOL_URL,

      canPerformAction: true,

      currentLogo: null,
      logoFile: null,

      currentPhoto: null,
      photoFile: null,
      
      currentLogoAgenda: null,
      logoFileAgenda: null,

      currentPhotoProfile: null,
      photoFileProfile: null,

      currentProfessionalProfileBackgroundImage: null,
      professionalProfileBackgroundImageFile: null,

      genderOptions: [
        { value: 'U', name: 'Não informado' },
        { value: 'M', name: 'Masculino' },
        { value: 'F', name: 'Feminino' }
      ],

      datePickerOptions: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        locale: 'pt-br'
      },

      specialities: [],

      durations: [
        { value: '00:05:00', name: '5 Minutos' },
        { value: '00:10:00', name: '10 Minutos' },
        { value: '00:15:00', name: '15 Minutos' },
        { value: '00:20:00', name: '20 Minutos' },
        { value: '00:25:00', name: '25 Minutos' },
        { value: '00:30:00', name: '30 Minutos' },
        { value: '00:35:00', name: '35 Minutos' },
        { value: '00:40:00', name: '40 Minutos' },
        { value: '00:45:00', name: '45 Minutos' },
        { value: '00:50:00', name: '50 Minutos' },
        { value: '01:00:00', name: '60 Minutos' },
        { value: '01:30:00', name: '90 Minutos' },
        { value: '02:00:00', name: '120 Minutos' }
      ],

      // terms: [
      //   { value: 'f;consulta', name: 'Consulta' },
      //   { value: 'f;consulta por ordem de chegada', name: 'Consulta (Ordem de Chegada)' },
      //   { value: 'f;sessão', name: 'Sessão' },
      //   { value: 'm;exame', name: 'Exame' },
      //   { value: 'm;exame por ordem de chegada', name: 'Exame (Ordem de Chegada)' },
      //   { value: 'm;horário', name: 'Horário' }
      // ],

      breakForm: {
        id: null,
        day_of_week: null,
        start_time: null,
        end_time: null,
        type: 'BREAK',
        new: true
      },

      daysOfWeekEnabled: [],
      schedules: [],
      breaks: [],
      appointmentTypes: [],
      appointmentFormats: [],
      professionals: [],
      healthPlans: [],

      fieldType: null,
      fieldTypes: [
        { value: 'agenda', name: 'Agenda Online', icon: 'far fa-calendar-alt' },
        { value: 'email', name: 'E-mail', icon: 'far fa-envelope' },
        { value: 'address', name: 'Endereço', icon: 'far fa-map-marker-alt' },
        { value: 'instagram', name: 'Instagram', icon: 'fab fa-instagram' },
        { value: 'link', name: 'Link', icon: 'far fa-link' },
        { value: 'phone', name: 'Telefone', icon: 'far fa-phone fa-flip-horizontal' },
        { value: 'text', name: 'Texto livre', icon: '' },
        { value: 'whatsapp', name: 'Whatsapp', icon: 'fab fa-whatsapp' }
      ],
      backgroundImageStyles: [
        { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' },
        { value: 'contain', name: 'Conter', css: 'background-size:contain;' },
        { value: 'repeat', name: 'Repetir', css: 'background-repeat:repeat;' },
      ],

      agendas: [],

      fieldForm: {
        id: null,
        type: null,
        order: 0,
        name: '',
        content: '',
        url: '',
        show_icon: { value: true, name: 'Sim' }
      },

      showIconOptions: [
        { value: true, name: 'Sim' },
        { value: false, name: 'Não' }
      ],

      step1Form: {
        logo: null,
        delete_logo: false,
        name: null,
        email: null,
        document: null,
        telephone: null,
        cellphone: null,
        address: {
          id: null,
          zip_code: null,
          address: null,
          number: null,
          complement: null,
          neighborhood: null,
          city: null,
          state: null,
          country: 'Brazil'
        }
      },

      step2Form: {
        id: null,
        photo: null,
        delete_photo: false,
        name: '',
        document: '',
        birthday: '',
        indicator_color: '#24a7f0',
        commission_percentage: 0,
        gender: '',
        email: '',
        telephone: '',
        cellphone: '',
        specialities: [],
        professional_registration: {
          id: null,
          council: null,
          state: null,
          number: null
        }
      },

      step3Form: {
        id: null,
        logo: null,
        delete_logo: false,
        name: '',
        duration: { value: '00:30:00', name: '30 Minutos' },
        // term: { value: 'f;consulta', name: 'Consulta' },
        start_date: this.moment().format('YYYY-MM-DD'),
        end_date: this.moment().add(1, 'years').format('YYYY-MM-DD'),
        appointmentTypes: [],
        appointmentFormats: [],
        professionals: [],
        healthPlans: [],
        online_scheduling: false,
        online_scheduling_period: 30,
        show_professional_on_calendar: true,
        show_appointment_type_on_calendar: true,
        show_health_plan_on_calendar: true
      },

      step4Form: {
        id: null,
        photo: null,
        delete_photo: false,
        name: '',
        specialities: [],
        professional_registration: {
          id: null,
          council: null,
          state: null,
          number: null
        },
        professional_profile: {
          id: null,
          slug: null,
          primary_color: '#333333',
          secondary_color: '#999999',
          background_color: '#eeeeee',
          background_image: null,
          delete_background_image: false,
          background_image_style: { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' },
          enabled: true,
          items: []
        }
      }
    }
  },
  created: function () {
    if (this.api.hasOnboarded()) {
      this.$router.push('/dashboard');
    }
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem('user'));

    this.eventBus.$on('IS_LOADING', (isLoading) => {
      if(isLoading) {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null) {
          return;
        }
        this.isLoading = this.$loading.show({
          container: this.$refs.homeContent,
          canCancel: false,
          isFullPage: false,
          color: '#21A7F0',
          backgroundColor: '#212C3B'
        });
      } else {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null) {
          this.isLoading.hide();
          this.isLoading = null;
        }
      }
    });

    let client = this.user.person.client;
    this.step1Form.logo = client.logo;
    this.step1Form.name = client.name;
    this.step1Form.email = client.email;
    this.step1Form.document = client.document;
    this.step1Form.telephone = client.telephone;
    this.step1Form.cellphone = client.cellphone;
    if(client.address) {
      this.step1Form.address = client.address;
    }

    let person = this.user.person;
    this.step2Form.id = person.id;
    this.step2Form.photo = person.photo;
    this.step2Form.name = person.name;
    this.step2Form.email = person.email;
    this.step2Form.document = person.document;
    this.step2Form.telephone = person.telephone;
    this.step2Form.cellphone = person.cellphone;
    let gender = (person.gender == null || typeof person.gender == 'undefined') ? 'U' : person.gender;
    this.step2Form.gender = this.genderOptions.find(g => g.value == gender);

    for (let dow = 0; dow <= 6; dow++) {
      this.schedules.push({
        day_of_week: dow,
        start_time: '08:00',
        end_time: '18:00',
        type: 'AVAILABLE'
      });

      if (dow >= 1 && dow <= 5) {
        this.breaks.push({
          id: this.helpers.uuidv4(),
          day_of_week: dow,
          start_time: '12:00',
          end_time: '14:00',
          type: 'BREAK'
        })
      }
    }

    this.daysOfWeekEnabled = [1, 2, 3, 4, 5];

    this.professionals = [{value: person.id, name: person.name}];

    if(this.user.person.client.onboarding_step == 2) {
      await this.getSpecialties();
    }
    else if(this.user.person.client.onboarding_step == 3) {
      await this.getHealthPlans();
      await this.getAgenda();
    }
    else if(this.user.person.client.onboarding_step == 4) {
      await this.getPerson();
    }
  },
  methods: {
    logout() {
      this.$swal({
        title: 'Você tem certeza de que deseja sair?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sair',
        cancelButtonText: 'Cancelar',
        focusCancel: true
      }).then((res) => {
        if(res.value) {
          localStorage.clear();

          this.$Tawk.$endChat();
          this.eventBus.$emit('IS_LOGGED', false);
          this.$router.push('/login');
        }
      })
    },

    logoChanged() {
      this.step1Form.logo = null;
      if (this.logoFile) {
        const scope = this;
        const reader = new FileReader();
        reader.onload = (event) => {
          scope.step1Form.logo = event.target.result;
          scope.updateLogo();
        };
        reader.readAsDataURL(this.logoFile);
      }
      else {
        this.updateLogo();
      }
    },

    removeLogo() {
      this.$swal({
        title: 'Você tem certeza?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Remover marca',
        cancelButtonText: 'Cancelar',
        focusCancel: true
      }).then((res) => {
        if(res.value) {
          this.step1Form.logo = null;
          this.currentLogo = null;
          this.logoFile = null;
          this.step1Form.delete_logo = true;
          this.updateLogo();
        }
      });
    },

    updateLogo() {
      let logo = '';
      if(this.step1Form.logo != null) {
        logo = this.step1Form.logo;
      } else if(this.currentLogo != null) {
        logo = this.currentLogo;
      } else {
        logo = 'https://via.placeholder.com/70x70/eaf1f4/11a6f3';
      }
      if(document.getElementById('clientLogo')) {
        document.getElementById('clientLogo').style.backgroundImage = 'url("' + logo + '")';
      }
    },

    logoChangedAgenda() {
      this.step3Form.logo = null;
      if (this.logoFileAgenda) {
        const scope = this;
        const reader = new FileReader();
        reader.onload = (event) => {
          scope.step3Form.logo = event.target.result;
          scope.updateLogoAgenda();
        };
        reader.readAsDataURL(this.logoFileAgenda);
      }
      else {
        this.updateLogoAgenda();
      }
    },

    removeLogoAgenda() {
      this.$swal({
        title: 'Você tem certeza?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Remover marca',
        cancelButtonText: 'Cancelar',
        focusCancel: true
      }).then((res) => {
        if(res.value) {
          this.step3Form.logo = null;
          this.currentLogoAgenda = null;
          this.logoFileAgenda = null;
          this.step3Form.delete_logo = true;
          this.updateLogoAgenda();
        }
      });
    },

    updateLogoAgenda() {
      let logo = '';
      if(this.step3Form.logo != null) {
        logo = this.step3Form.logo;
      } else if(this.currentLogoAgenda != null) {
        logo = this.currentLogoAgenda;
      } else {
        logo = 'https://via.placeholder.com/70x70/eaf1f4/11a6f3';
      }
      if(document.getElementById('agendaLogo')) {
        document.getElementById('agendaLogo').style.backgroundImage = 'url("' + logo + '")';
      }
    },

    toggleDow(dow) {
      if (this.daysOfWeekEnabled.includes(dow)) {
        let index = this.daysOfWeekEnabled.indexOf(dow);
        this.daysOfWeekEnabled.splice(index, 1);

        this.breaks = this.breaks.filter(brk => {
          return brk.day_of_week != dow;
        })
      } else {
        this.daysOfWeekEnabled.push(dow);
        this.daysOfWeekEnabled.sort();
      }
    },

    getScheduleByDow(dow) {
      return this.schedules.find(schedule => {
        return schedule.type == 'AVAILABLE' && schedule.day_of_week == dow;
      });
    },

    openModalBreak(dow) {
      this.breakForm.day_of_week = dow;
      this.$bvModal.show('break-modal');
    },

    resetBreakModal() {
      this.breakForm = {
        id: null,
        day_of_week: null,
        start_time: null,
        end_time: null,
        type: 'BREAK',
        new: true
      };
    },

    async addBreak() {
      if(!this.canPerformAction)
        return false;

      this.canPerformAction = false;

      const isValid = await this.$refs.breakForm.validate();
      if(!isValid) {
        this.canPerformAction = true;
        return false;
      }

      let breakData = this.breakForm;

      if(breakData.id == null) {
        breakData.id = this.helpers.uuidv4();

        this.breaks.push(breakData);
      } else {
        this.breaks = this.breaks.map(brk => {
          if(brk.id == breakData.id) {
            brk = breakData;
          }

          return brk;
        });
      }

      this.$bvModal.hide('break-modal');

      this.canPerformAction = true;
    },

    removeBreak(id) {
      this.breaks = this.breaks.filter(brk => {
        return brk.id != id;
      });
    },

    getBreaks(dow) {
      let breaks = this.breaks.filter(brk => {
        return brk.day_of_week == dow;
      }).sort(function(a, b) {
        if(a.start_time < b.start_time) { return -1; }
        if(a.start_time > b.start_time) { return 1; }
        return 0;
      });

      return breaks;
    },

    findCep(value) {
      if(value == '00000-000' || value == '99999-999') {
        this.step1Form.address.address = 'Atendimento online';
        this.step1Form.address.number = '-';
        this.step1Form.address.neighborhood = '-';
        this.step1Form.address.city = '-';
        this.step1Form.address.state = '-';
      } else if(value.length == 9) {
        axios.get('https://viacep.com.br/ws/'+value+'/json/').then(res => {
          if(typeof res.data.erro == 'undefined') {
            let cepData = res.data;
            this.step1Form.address.address = cepData.logradouro;
            this.step1Form.address.neighborhood = cepData.bairro;
            this.step1Form.address.city = cepData.localidade;
            this.step1Form.address.state = cepData.uf;

            this.$refs.number.$el.focus();
          } else {

            this.$refs.address.$el.focus();
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response CEP', res);
        }).catch(err => {
          this.$swal('Ops...', 'Não conseguimos localizar o seu CEP! Por favor, preencha os dados manualmente.', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error CEP', err.response);
        });
      }
    },

    photoChanged() {
      this.step2Form.photo = null;
      if (this.photoFile) {
        const scope = this;
        const reader = new FileReader();
        reader.onload = (event) => {
          scope.step2Form.photo = event.target.result;
          scope.updatePhoto();
        };
        reader.readAsDataURL(this.photoFile);
      }
      else {
        this.updatePhoto();
      }
    },

    removePhoto() {
      this.$swal({
        title: 'Você tem certeza?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Remover foto',
        cancelButtonText: 'Cancelar',
        focusCancel: true
      }).then((res) => {
        if(res.value) {
          this.step2Form.photo = null;
          this.currentPhoto = null;
          this.photoFile = null;
          this.step2Form.delete_photo = true;
          this.updatePhoto();
        }
      });
    },

    updatePhoto() {
      let photo = '';
      if(this.step2Form.photo != null) {
        photo = this.step2Form.photo;
      } else if(this.currentPhoto != null) {
        photo = this.currentPhoto;
      } else {
        photo = 'https://via.placeholder.com/70x70/eaf1f4/11a6f3';
      }
      if(document.getElementById('personPhoto')) {
        document.getElementById('personPhoto').style.backgroundImage = 'url("' + photo + '")';
      }
      if(document.getElementById('personPhotoPreview')) {
        document.getElementById('personPhotoPreview').style.backgroundImage = 'url("' + photo + '")';
      }
    },

    photoChangedProfile() {
      this.step4Form.photo = null;
      if (this.photoFileProfile) {
        const scope = this;
        const reader = new FileReader();
        reader.onload = (event) => {
          scope.step4Form.photo = event.target.result;
          scope.updatePhotoProfile();
        };
        reader.readAsDataURL(this.photoFileProfile);
      }
      else {
        this.updatePhotoProfile();
      }
    },

    professionalProfileBackgroundImageChanged() {
      this.step4Form.professional_profile.background_image = null;
      if (this.professionalProfileBackgroundImageFile) {
        const scope = this;
        const reader = new FileReader();
        reader.onload = (event) => {
          scope.step4Form.professional_profile.background_image = event.target.result;
          scope.updateProfessionalProfileBackgroundImage();
        };
        reader.readAsDataURL(this.professionalProfileBackgroundImageFile);
      }
      else {
        this.updateProfessionalProfileBackgroundImage();
      }
    },

    removePhotoProfile() {
      this.$swal({
        title: 'Você tem certeza?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Remover foto',
        cancelButtonText: 'Cancelar',
        focusCancel: true
      }).then((res) => {
        if(res.value) {
          this.step4Form.photo = null;
          this.currentPhotoProfile = null;
          this.photoFileProfile = null;
          this.step4Form.delete_photo = true;
          this.updatePhotoProfile();
        }
      });
    },

    removeProfessionalProfileBackgroundImagePhoto() {
      this.$swal({
        title: 'Você tem certeza?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Remover foto',
        cancelButtonText: 'Cancelar',
        focusCancel: true
      }).then((res) => {
        if(res.value) {
          this.step4Form.professional_profile.background_image = null;
          this.currentProfessionalProfileBackgroundImage = null;
          this.professionalProfileBackgroundImageFile = null;
          this.step4Form.professional_profile.delete_background_image = true;
          this.updateProfessionalProfileBackgroundImage();
        }
      });
    },

    updatePhotoProfile() {
      let photo = '', hasPhoto = true;
      if(this.step4Form.photo != null) {
        photo = this.step4Form.photo;
      } else if(this.currentPhotoProfile != null) {
        photo = this.currentPhotoProfile;
      } else {
        hasPhoto = false;
        photo = 'https://via.placeholder.com/70x70/eaf1f4/11a6f3';
      }
      if(document.getElementById('personPhotoProfile')) {
        document.getElementById('personPhotoProfile').style.backgroundImage = 'url("' + photo + '")';
      }
      if(document.getElementById('personPhotoPreview')) {
        document.getElementById('personPhotoPreview').style.backgroundImage = 'url("' + photo + '")';
      }
      if(document.getElementById('professionalProfilePhotoPreview')) {
        photo = hasPhoto ? photo : require('@/assets/images/digital-card-avatar.jpg');
        document.getElementById('professionalProfilePhotoPreview').style.backgroundImage = 'url("' + photo + '")';
      }
    },

    updateProfessionalProfileBackgroundImage() {
      let photo = '';
      if(this.step4Form.professional_profile.background_image != null) {
        photo = this.step4Form.professional_profile.background_image;
      } else if(this.currentProfessionalProfileBackgroundImage != null) {
        photo = this.currentProfessionalProfileBackgroundImage;
      } else {
        photo = '';
      }
      if(document.getElementById('professionalProfileBackgroundImage')) {
        document.getElementById('professionalProfileBackgroundImage').style.backgroundImage = 'url("' + photo + '")';
      }
      if(document.getElementById('professionalProfilePreview')) {
        document.getElementById('professionalProfilePreview').style.backgroundImage = 'url("' + photo + '")';
      }
    },

    async getSpecialties() {
      await this.api.getSpecialities().then(res => {
        if(this.leavingPage) {
          return;
        }
        this.specialities = [];
        res.data.forEach(speciality => {
          this.specialities.push({ value: speciality.id, name: speciality.name });
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Specialities', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar as especialidades! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Specialities', err.response);
      });
    },

    async getHealthPlans() {
      await this.api.getHealthPlans({all: true}).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.healthPlans = [];
        res.data.forEach(health_plan => {
          this.healthPlans.push({ value: health_plan.id, name: health_plan.name });
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Health Plans', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar os convênios! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Health Plans', err.response);
      });
    },

    async getAgenda() {
      await this.api.getAgendas({default: true}).then(res => {
        if(this.leavingPage) {
          return;
        }
        let agendaData = res.data;

        this.step3Form = {
          id: agendaData.id,
          logo: null,
          delete_logo: false,
          name: agendaData.name,
          duration: this.durations.find(d => d.value == agendaData.duration),
          // term: this.terms.find(t => t.value == agendaData.term),
          start_date: agendaData.start_date.substr(0, 10),
          end_date: agendaData.end_date.substr(0, 10),
          appointmentTypes: [],
          appointmentFormats: [],
          professionals: [],
          healthPlans: [],
          online_scheduling: agendaData.online_scheduling,
          online_scheduling_period: agendaData.online_scheduling_period,
          show_professional_on_calendar: agendaData.show_professional_on_calendar,
          show_appointment_type_on_calendar: agendaData.show_appointment_type_on_calendar,
          show_health_plan_on_calendar: agendaData.show_health_plan_on_calendar
        };
        this.currentLogoAgenda = agendaData.logo;
        this.updateLogoAgenda();

        agendaData.appointment_types.forEach(appointmentType => {
          this.step3Form.appointmentTypes.push({value: appointmentType.id, name: appointmentType.type});
        });
        this.appointmentTypes = this.step3Form.appointmentTypes;

        agendaData.appointment_formats.forEach(appointmentFormat => {
          this.step3Form.appointmentFormats.push({value: appointmentFormat.id, name: appointmentFormat.format});
        });
        this.appointmentFormats = this.step3Form.appointmentFormats;

        agendaData.professionals.forEach(professional => {
          this.step3Form.professionals.push({value: professional.id, name: professional.name});
        });

        this.daysOfWeekEnabled = [];
        agendaData.schedules.forEach(schedule => {
          if(schedule.type == 'AVAILABLE' && !this.daysOfWeekEnabled.includes(schedule.day_of_week)) {
            this.schedules[schedule.day_of_week].start_time = schedule.start_time.substr(0, 5);
            this.schedules[schedule.day_of_week].end_time = schedule.end_time.substr(0, 5);
            this.daysOfWeekEnabled.push(schedule.day_of_week);
          }
        });

        this.daysOfWeekEnabled.sort();

        this.breaks = agendaData.schedules.filter(schedule => {
          schedule.start_time = schedule.start_time.substr(0, 5);
          schedule.end_time = schedule.end_time.substr(0, 5);
          schedule.new = false;
          return schedule.type == 'BREAK';
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Agenda', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        if(this.leavingPage) {
          return;
        }

        this.$swal('Ops...', 'Não conseguimos carregar a sua agenda! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Agenda', err.response);
      });
    },

    async getPerson() {
      await this.api.getPerson(this.user.person.id, {is_professional_profile: 1}).then(res => {
        this.canPerformAction = true;
        if(this.leavingPage) {
          return;
        }
        let fieldOrder = null;

        let personData = res.data;
        let professionalRegistration = (personData.professional_registration == null) ? {
          id: null,
          council: null,
          state: null,
          number: null
        } : personData.professional_registration;
        let professionalProfile = (personData.professional_profile == null) ? {
          id: null,
          slug: null,
          primary_color: '#333333',
          secondary_color: '#999999',
          background_color: '#eeeeee',
          background_image: null,
          delete_background_image: false,
          background_image_style: { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' },
          enabled: true,
          items: []
        } : personData.professional_profile;
        if(personData.professional_profile != null) {
          professionalProfile.background_image_style = this.backgroundImageStyles.find(style => style.value === professionalProfile.background_image_style);
          if(professionalProfile.background_image_style === undefined) {
            professionalProfile.background_image_style = { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' };
          }
        }
        else {
          fieldOrder = 0
          if(personData.email != null) {
            professionalProfile.items.push({
              id: this.helpers.uuidv4(),
              type: 'email',
              name: 'E-mail',
              content: personData.email,
              url: null,
              order: fieldOrder,
              show_icon: true
            });
            fieldOrder++;
          }
          if(personData.cellphone != null) {
            professionalProfile.items.push({
              id: this.helpers.uuidv4(),
              type: 'whatsapp',
              name: 'Whatsapp',
              content: personData.cellphone,
              url: null,
              order: fieldOrder,
              show_icon: true
            });
            fieldOrder++;
          }
          if(personData.telephone != null) {
            professionalProfile.items.push({
              id: this.helpers.uuidv4(),
              type: 'phone',
              name: 'Telefone',
              content: personData.telephone,
              url: null,
              order: fieldOrder,
              show_icon: true
            });
            fieldOrder++;
          }
        }

        this.step4Form = {
          id: personData.id,
          name: personData.name,
          photo: null,
          delete_photo: false,
          specialities: [],
          professional_registration: professionalRegistration,
          professional_profile: professionalProfile
        };
        this.currentPhotoProfile = personData.photo;
        this.updatePhotoProfile();

        if(typeof personData.specialities != 'undefined') {
          personData.specialities.forEach(speciality => {
            this.step4Form.specialities.push({value: speciality.id, name: speciality.name});
          });
        }

        if(this.step4Form.professional_profile.slug === null || this.step4Form.professional_profile.slug === '') {
          this.step4Form.professional_profile.slug = this.slugify(this.step4Form.name);
        }
        this.currentProfessionalProfileBackgroundImage = professionalProfile.background_image;
        this.updateProfessionalProfileBackgroundImage();

        if(typeof personData.agendas != 'undefined') {
          personData.agendas.forEach(agenda => {
            if(agenda.online_scheduling) {
              this.agendas.push({value: this.aolUrl + agenda.id, name: agenda.name});
              if(fieldOrder != null) {
                professionalProfile.items.push({
                  id: this.helpers.uuidv4(),
                  type: 'agenda',
                  name: 'Agenda Online',
                  content: '',
                  url: this.aolUrl + agenda.id,
                  order: fieldOrder,
                  show_icon: true
                });
              }
            }
          });
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Person', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }

        this.$swal('Ops...', 'Não conseguimos carregar este profissional! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Person', err.response);
      });
    },

    async saveStep1() {
      if(!this.canPerformAction)
        return false;
      const isValid = await this.$refs.step1Form.validate();
      if(!isValid) {
        return false;
      }
      this.canPerformAction = false;
      this.eventBus.$emit('IS_LOADING', true);
      this.api.updateClient(this.step1Form).then(res => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;

        this.logoFile = null;
        this.step1Form.logo = null;
        this.step1Form.delete_logo = false;
        this.currentLogo = res.data.logo;
        this.updateLogo();
        this.eventBus.$emit('CLIENT_LOGO_CHANGED', res.data.logo);

        this.user.person.client.logo = res.data.logo;
        this.user.person.client.name = res.data.name;
        this.user.person.client.email = res.data.email;
        this.user.person.client.document = res.data.document;
        this.user.person.client.telephone = res.data.telephone;
        this.user.person.client.cellphone = res.data.cellphone;
        this.user.person.client.address = res.data.address;
        this.user.person.client.onboarding_step = res.data.onboarding_step;
        localStorage.setItem('user', JSON.stringify(this.user));

        this.getSpecialties();

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Update Configurations', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;
        let msg = 'Não conseguimos atualizar os dados do consultório! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

        switch (err.response.status) {
          case 422: msg = err.response.data.errors.join('\r\n'); break;
        }

        this.$swal('Ops...', msg, 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Update Configurations', err.response);
      });
    },

    async saveStep2() {
      if(!this.canPerformAction)
        return false;
      const isValid = await this.$refs.step2Form.validate();
      if(!isValid) {
        return false;
      }
      this.canPerformAction = false;
      this.eventBus.$emit('IS_LOADING', true);
      let personData = {
        id: this.step2Form.id,
        type: 'PROFESSIONAL',
        photo: this.step2Form.photo,
        delete_photo: this.step2Form.delete_photo,
        name: this.step2Form.name,
        email: this.step2Form.email,
        document: this.step2Form.document,
        cellphone: this.step2Form.cellphone,
        telephone: this.step2Form.telephone,
        gender: this.step2Form.gender.value,
        birthday: this.step2Form.birthday,
        indicator_color: this.step2Form.indicator_color,
        professional_registration: {
          id: this.step2Form.professional_registration.id,
          council: this.step2Form.professional_registration.council,
          state: this.step2Form.professional_registration.state,
          number: this.step2Form.professional_registration.number
        },
        commission_percentage: this.step2Form.commission_percentage,
        specialities: this.step2Form.specialities.map(speciality => { return speciality.value; })
      };

      this.api.updatePerson(this.step2Form.id, personData).then(res => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;

        if (res.status == 200) {
          this.photoFile = null;
          this.step2Form.photo = null;
          this.step2Form.delete_photo = false;
          this.currentPhoto = res.data.photo;

          this.user.person.photo = res.data.photo;
          this.user.person.name = res.data.name;
          this.user.person.email = res.data.email;
          this.user.person.document = res.data.document;
          this.user.person.telephone = res.data.telephone;
          this.user.person.cellphone = res.data.cellphone;
          this.user.person.gender = res.data.gender;
          this.user.person.birthday = res.data.birthday;
          this.user.person.indicator_color = res.data.indicator_color;
          this.user.person.commission_percentage = res.data.commission_percentage;
          this.user.person.client.onboarding_step = 3;

          localStorage.setItem('user', JSON.stringify(this.user));

          this.professionals = [{value: res.data.id, name: res.data.name}];

          this.getHealthPlans();
          this.getAgenda();
        } else {
          this.$swal('Ops...', 'Ocorreu um erro ao atualizar o profissional! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Update Person', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;

        let msg = 'Não conseguimos atualizar o profissional! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

        switch (err.response.status) {
          case 422: msg = err.response.data.errors.join('\r\n'); break;
        }

        this.$swal('Ops...', msg, 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Update Person', err.response);
      });
    },

    async saveStep3() {
      if(!this.canPerformAction)
        return false;
      const isValid = await this.$refs.step3Form.validate();
      if(!isValid) {
        return false;
      }
      this.canPerformAction = false;
      this.eventBus.$emit('IS_LOADING', true);

      let agendaData = {
        id: this.step3Form.id,
        name: this.step3Form.name,
        duration: this.step3Form.duration.value,
        // term: this.step3Form.term.value,
        start_date: this.step3Form.start_date,
        end_date: this.step3Form.end_date,
        appointment_types: this.step3Form.appointmentTypes.map(appointmentType => {
          return appointmentType.value;
        }),
        appointment_formats: this.step3Form.appointmentFormats.map(appointmentFormat => {
          return appointmentFormat.value;
        }),
        professionals: this.step3Form.professionals.map(professional => {
          return professional.value;
        }),
        health_plans: this.step3Form.healthPlans.map(healthPlan => {
          return healthPlan.value;
        }),
        online_scheduling: this.step3Form.online_scheduling,
        online_scheduling_period: this.step3Form.online_scheduling_period,
        show_professional_on_calendar: this.step3Form.show_professional_on_calendar,
        show_appointment_type_on_calendar: this.step3Form.show_appointment_type_on_calendar,
        show_health_plan_on_calendar: this.step3Form.show_health_plan_on_calendar,
        logo: this.step3Form.logo,
        delete_logo: this.step3Form.delete_logo,
        whatsapp_id: null
      };

      let schedulesActivated = this.schedules.filter(schedule => {
        return this.daysOfWeekEnabled.includes(schedule.day_of_week);
      });

      schedulesActivated = schedulesActivated.concat(this.breaks.map(brk => {
        if(brk.new)
          brk.id = null;

        return brk;
      }));

      agendaData.schedules = schedulesActivated;

      this.api.updateAgenda(this.step3Form.id, agendaData).then(res => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;

        if (res.status == 200) {

          this.user.person.client.onboarding_step = 4;

          localStorage.setItem('user', JSON.stringify(this.user));

          this.getPerson();
        } else {
          this.$swal('Ops...', 'Ocorreu um erro ao atualizar a agenda! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Update Agenda', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;

        let msg = 'Não conseguimos atualizar esta agenda! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

        switch (err.response.status) {
          case 422: msg = err.response.data.errors.join('\r\n'); break;
        }

        this.$swal('Ops...', msg, 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Update Agenda', err.response);
      });
    },

    async saveStep4() {
      if(!this.canPerformAction)
        return false;
      const isValid = await this.$refs.step4Form.validate();
      if(!isValid) {
        return false;
      }
      this.canPerformAction = false;
      this.eventBus.$emit('IS_LOADING', true);

      let professionalProfileData = {
        id: this.step4Form.id,
        photo: this.step4Form.photo,
        delete_photo: this.step4Form.delete_photo,
        professional_profile: {
          id: this.step4Form.professional_profile.id,
          slug: this.step4Form.professional_profile.slug,
          primary_color: this.step4Form.professional_profile.primary_color,
          secondary_color: this.step4Form.professional_profile.secondary_color,
          background_color: this.step4Form.professional_profile.background_color,
          background_image: this.step4Form.professional_profile.background_image,
          delete_background_image: this.step4Form.professional_profile.delete_background_image,
          background_image_style: this.step4Form.professional_profile.background_image_style.value,
          enabled: this.step4Form.professional_profile.enabled,
          items: this.step4Form.professional_profile.items
        }
      };

      this.api.storeProfessionalProfile(this.step4Form.id, professionalProfileData).then(res => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;

        if (res.status == 201) {
          this.user.person.client.onboarding_step = null;

          localStorage.setItem('user', JSON.stringify(this.user));

          this.$swal('Uhull \\o/', 'Seu cadastro está completo! Você já está pronto para utilizar o sistema!', 'success').then(() => {
            this.$router.push('/dashboard');
          });
        } else {
          this.$swal('Ops...', 'Ocorreu um erro ao cadastrar o cartão digital! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Store Person', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;

        let response = err.response;
        let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos cadastrar o cartão digital! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

        this.$swal('Ops...', message, 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Store Person', err.response);
      });
    },


    getFormattedProfessionalRegistration() {
      if(this.step4Form.professional_registration == null || this.step4Form.professional_registration.number == null) {
        return '';
      }
      let registration = [];
      if(this.step4Form.professional_registration.council != null) {
        registration.push(this.step4Form.professional_registration.council);
      }
      if(this.step4Form.professional_registration.state != null) {
        registration.push(this.step4Form.professional_registration.state);
      }
      registration.push(this.step4Form.professional_registration.number);
      return registration.join(' ');
    },

    getFormattedSpecialties() {
      let specialties = [];
      this.step4Form.specialities.forEach(specialty => {
        specialties.push(specialty.name);
      });
      return specialties.join(' | ');
    },

    getProfileFieldIcon(fieldType) {
      return this.fieldTypes.find(type => type.value === fieldType).icon;
    },

    slugify(text) {
      return text
          .toString()                     // Cast to string
          .toLowerCase()                  // Convert the string to lowercase letters
          .normalize('NFD')       // The normalize() method returns the Unicode Normalization Form of a given string.
          .trim()                         // Remove whitespace from both sides of a string
          .replace(/\s+/g, '-')           // Replace spaces with -
          .replace(/[^\w-]+/g, '')       // Remove all non-word chars
          .replace(/--+/g, '-');        // Replace multiple - with single -
    },

    profileFieldsChanged() {
      for(let index = 0; index < this.step4Form.professional_profile.items.length; index++) {
        this.step4Form.professional_profile.items[index].order = index;
      }
    },

    async openFieldModal() {
      if(!this.canPerformAction || this.fieldType == null)
        return false;

      this.canPerformAction = false;

      let currentOrder = this.step4Form.professional_profile.items.length;
      if(currentOrder === 20) {
        this.canPerformAction = true;
        this.$swal('Desculpe', 'Não é possível adicionar mais campos!', 'error');
        return false;
      }
      if (this.fieldType.value != 'link' && this.fieldType.value != 'text') {
        this.fieldForm.name = this.fieldType.name;
      }

      this.canPerformAction = true;
      this.fieldForm.type = this.fieldType;
      this.fieldForm.order = currentOrder;
      this.$bvModal.show('field-modal');
    },
    resetFieldModal() {
      this.fieldForm = {
        id: null,
        type: null,
        order: 0,
        name: '',
        content: '',
        url: '',
        show_icon: { value: true, name: 'Sim' }
      };
    },
    async addField() {
      if(!this.canPerformAction)
        return false;

      this.canPerformAction = false;

      const isValid = await this.$refs.fieldForm.validate();
      if(!isValid) {
        this.canPerformAction = true;
        return false;
      }

      let url = this.fieldForm.url;
      if(this.fieldForm.type.value == 'agenda') {
        url = url.value;
      }

      let fieldData = {
        id: this.fieldForm.id,
        type: this.fieldForm.type.value,
        name: this.fieldForm.name,
        content: this.fieldForm.content,
        url: url,
        order: this.fieldForm.order,
        show_icon: this.fieldForm.show_icon.value
      };

      if(fieldData.id == null) {
        fieldData.id = this.helpers.uuidv4();

        this.step4Form.professional_profile.items.push(fieldData);
      } else {
        this.step4Form.professional_profile.items = this.step4Form.professional_profile.items.map(field => {
          if(field.id == fieldData.id)
            field = fieldData;

          return field;
        });
      }

      this.step4Form.professional_profile.items.sort((a, b) => (a.order > b.order)?1:-1);

      this.$bvModal.hide('field-modal');
      this.canPerformAction = true;
    },
    async editField(index) {
      if(!this.canPerformAction)
        return false;

      this.canPerformAction = false;

      let field = this.step4Form.professional_profile.items[index];

      this.fieldForm = {
        id: field.id,
        type: this.fieldTypes.find(type => type.value === field.type),
        order: field.order,
        name: field.name,
        content: field.content,
        url: field.url,
        show_icon: this.showIconOptions.find(showIcon => showIcon.value === field.show_icon),
      };
      if(field.type == 'agenda') {
        this.fieldForm.url = this.agendas.find(agenda => agenda.value === field.url);
      }

      this.$bvModal.show('field-modal');
      this.canPerformAction = true;
    },
    async removeField(fieldId) {
      if(!this.canPerformAction)
        return false;

      this.canPerformAction = false;

      this.step4Form.professional_profile.items = this.step4Form.professional_profile.items.filter(field => {
        return field.id != fieldId
      });

      this.$bvModal.hide('field-modal');
      this.canPerformAction = true;
    },
    getDigitalCardUrl() {
      return this.digitalCardUrl + this.step4Form.professional_profile.slug;
    },
    copyDigitalCardUrl() {
      this.$refs.digitalCardUrl.select();
      document.execCommand('copy');
      this.$swal('Uhull \\o/', 'Copiado com sucesso!', 'success');
    }
  },
  beforeRouteLeave (to, from, next) {
    this.leavingPage = true;
    next();
  }
}
</script>

<style scoped lang="scss">
.onboarding {
  min-height: 100vh;
  background-image: linear-gradient(to bottom right, #eaeaea , #cccccc);

  .onboarding-full-bg {
    min-height: 100vh;
    background: url(../assets/images/bg-login.jpg) center center;
  }

  .box-onboarding {
    font-family: 'sf_pro_displaymedium';
    background-color: #ffffff;
    color: $bunting;
  }

  .onboarding-steps {
    margin-left: -15px;
    margin-right: -15px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    .onboarding-step {
      text-align: center;
      padding: 10px 6px;
      flex-grow: 1;
      flex-basis: 0;
      align-self: stretch;
      border: 1px solid $linkWater;
      border-left: 0;
      background-color: $mystic;
      color: $cadetGray;

      &:last-child {
        border-right: 0;
      }

      &.active {
        //background-color: #ffffff;
        //color: $curiousBlue;
        background-color: $curiousBlue;
        color: #ffffff;
      }
    }
  }

  h6 {
    font-size: 1.05rem;
  }

  .logo-container {
    position: relative;
    text-align: center;

    .client-logo {
      cursor: pointer;
      width: 130px;
      height: 130px;
      background: #f0f0f0 no-repeat 50%;
      background-size: contain;
      border: 1px solid $linkWater;
    }

    .agenda-logo {
      cursor: pointer;
      width: 130px;
      height: 130px;
      background: #f0f0f0 no-repeat 50%;
      background-size: contain;
      border: 1px solid $linkWater;
    }

    .delete-logo {
      position: absolute;
      top: 0;
      right: 0;
      padding: 0.25rem 0.45rem;
      font-size: 0.8rem;
    }
  }

  .photo-container {
    position: relative;
    text-align: center;

    .person-photo {
      cursor: pointer;
      width: 130px;
      height: 130px;
      background: #f0f0f0 no-repeat 50%;
      background-size: contain;
      border: 1px solid $linkWater;

      &#personPhotoProfile,
      &#professionalProfileBackgroundImage {
        width: 110px;
        height: 110px;
      }

      &#personPhotoPreview {
        cursor: default;
      }
    }

    .delete-photo {
      position: absolute;
      top: 0;
      right: 0;
      padding: 0.25rem 0.45rem;
      font-size: 0.8rem;
    }
  }

  .box-cj {
    background: #FFFFFF;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    margin-bottom: 30px;

    &.box-collapse {
      margin-bottom: -5px;
      border-radius: 4px 4px 0 0;
    }

    .header {
      padding: 8px 16px;
      border-bottom: 1px solid $athenGray2;

      .title {
        font-size: 15px;
        margin-bottom: 0;
      }
    }

    .footer {
      padding: 8px 16px;
      border-top: 1px solid $athenGray2;
    }

    .content {
      padding: 8px 16px;

      .sub-title {
        font-size: 16px;
        margin-bottom: 15px;
        color: $waikawaGray;
      }

      .valid-between {
        li {
          border: 1px solid $mystic;
          padding: 10px 20px;

          .label {
            width: 100%;
            font-size: 12px;
            color: $cadetGray;
            float: left;
            margin-bottom: -5px;
          }

          .date {
            font-size: 16px;
            color: $waikawaGray;
          }

          &:first-child {
            border-radius: 4px 4px 0 0;
          }

          &:last-child {
            border-top: 0;
            border-radius: 0 0 4px 4px;
          }
        }
      }

      th {
        font-size: 14px;
        color: $cadetGray;
        border-top: 0;
      }

      tbody {
        font-size: 16px;
        color: $waikawaGray;

        .line-add {
          padding: 10px 0;
        }

        tr:nth-child(even) {
          background-color: $whisper;
        }

        tr:nth-child(odd) {
        }
      }
    }
  }

  .breaks {
    li {
      position: relative;
      padding: 5px 0;
      cursor: pointer;
      font-size: 15px;

      .remove {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        opacity: 0;
        top: 0;
        left: 0;
        font-size: 0.8em;
        position: absolute;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.5s;
      }

      &:hover {
        .remove {
          opacity: 1;
        }
      }
    }
  }

  .copyDigitalCardUrlTextArea {
    width: 1px;
    height: 1px;
    padding: 0;
    opacity: 0;
  }

  //.onboarding-form {
  //  max-height: 800px;
  //  overflow-y: scroll;
  //}

  .logout-btn {
    cursor: pointer;
    color: $bunting;
    font-size: 16px;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
